import React from 'react';

import {FilterBarModuleProps} from "../models/filter-bar-module.props";
import {Compose, ComposeSettings} from "../../../core/components/composers/compose";
import {FilterBarModuleController} from "../filter-bar-module.controller";
import classNames from "classnames";
import styles from "../styles/filter-bar.module.scss";
import {FilterBarModuleQuickAccessButtons} from "./filter-bar-module.quick-access-buttons";
import {FilterBarModuleButton} from "./filter-bar-module.button";
import {ClockAssetsRequestParams} from "../../../core/icons/clock";
// import {COLORS} from "../../../core/consts";
// import {THEME} from "../../../core/app/consts";
import {FILTER_BAR_MODULE} from "../filter-bar-module.consts";
import {useThemeColor} from "../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../core/app/consts/colors";

export class FilterBarModuleComponentProps extends FilterBarModuleProps {}

export const FilterBarModuleComponent = (({
                                            controller,
                                            onLiveClick,
                                            shouldRenderLiveButton,
                                            isLive,
                                            shouldRenderSortButton,
                                            isSorted,
                                            showOdds,
                                            disableSortButton,
                                            onSortClick,
                                            onShowOddsClick,
                                          }: FilterBarModuleComponentProps) => {
  const {terms} = controller;
  const {WEB_SCORES_BY_TIME_FILTER} = terms;

  const onToggleClick = (toggleType, isActive) => {
    controller.action(FILTER_BAR_MODULE.ANALYTICS.ACTION_TYPES.toggleClick, {toggleType, clickType: Number(isActive)})
  }

  const quickAccessButtonsProps = {
    controller,
    shouldRenderLiveButton,
    onLiveClick,
    onShowOddsClick,
    onToggleClick,
    isLive,
    showOdds
  }

  const byTimeButtonProps = {
    label: WEB_SCORES_BY_TIME_FILTER,
    isActive: isSorted,
    className: styles.sort_button,
    hasIcon: true,
    shouldRenderButton: shouldRenderSortButton,
    isDisabled: disableSortButton,
    onClick: () => {
      onToggleClick(FILTER_BAR_MODULE.ANALYTICS.TOGGLE_TYPES.byTime, !isSorted)
      onSortClick();
    },
    iconSource: new ClockAssetsRequestParams(16, 16, useThemeColor(COLORS.whitePrimary))
  }

  return (
    <div className={classNames(styles.filter_bar)}>
      <FilterBarModuleQuickAccessButtons {...quickAccessButtonsProps}/>
      <FilterBarModuleButton {...byTimeButtonProps}/>
    </div>
  )
})

const settings: ComposeSettings = {
  component: FilterBarModuleComponent,
  propsType: FilterBarModuleComponentProps,
  controllerType: FilterBarModuleController,

  observe: true,
  createModule: true,
};

export default Compose(settings);
